import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHero,
  StyledPreTitle,
  StyledWarning,
  StyledWrapper
} from './JuniorsHero.styled';

const JuniorsHero: React.FC = () => {
  const { t } = useI18n('helping-juniors');
  const { locale } = useRouter();

  return (
    <StyledHero>
      <StyledWrapper>
        <StyledContainer>
          <div>
            <StyledPreTitle>
              {t('helping-juniors.hero.pre-title')}
            </StyledPreTitle>
            <Heading1>{t('helping-juniors.hero.title')}</Heading1>
            <p>{t('helping-juniors.hero.desc')}</p>
            {locale === 'en' && (
              <StyledWarning>
                <FontAwesomeIcon icon={faLanguage} />
                <span>{t('helping-juniors.hero.warning')}</span>
              </StyledWarning>
            )}
          </div>
          <img
            src={getPublicPath(`/images/helpingJuniors/hero.svg`)}
            alt=""
            role="presentation"
          />
        </StyledContainer>
      </StyledWrapper>
    </StyledHero>
  );
};

export default JuniorsHero;
